import { render } from "./TipItemExpanded.vue?vue&type=template&id=3311aa26&scoped=true"
import script from "./TipItemExpanded.vue?vue&type=script&lang=js"
export * from "./TipItemExpanded.vue?vue&type=script&lang=js"

import "./TipItemExpanded.vue?vue&type=style&index=0&id=3311aa26&scoped=true&lang=scss"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3311aa26"]])

export default __exports__